// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-range-header[data-v-762b7ce6] {\n  padding: 0 0.53333rem;\n  height: 1.33333rem;\n}\n.time-range-header .title[data-v-762b7ce6] {\n  font-size: 0.42667rem;\n}\n.time-range-header .confirm[data-v-762b7ce6] {\n  font-size: 0.34667rem;\n  color: #576b95;\n}\n.time-range-header .cancel[data-v-762b7ce6] {\n  font-size: 0.34667rem;\n}\n.van-popup[data-v-762b7ce6] {\n  border-radius: 0;\n}\n", ""]);
// Exports
module.exports = exports;
